import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TestHookDirective } from '@core/ui';
import {
	AnalyticsEvent,
	AnalyticsService,
} from 'src/app/shared/services/analytics/analytics.service';
import { ButtonComponent } from 'src/app/ui/button/button.component';
import { ContentHeaderComponent } from 'src/app/ui/content-header/content-header.component';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';
import { ColSpanDirective } from 'src/app/ui/grid/col-span.directive';
import { PageComponent } from 'src/app/ui/page/page.component';
import { TabComponent } from 'src/app/ui/tabs/tab/tab.component';
import { TabsComponent } from 'src/app/ui/tabs/tabs.component';
import { CreateDocPackageDrawerComponent } from './create-doc-package-drawer/create-doc-package-drawer.component';
import { TestHooks } from './documents-v2.hooks';
import { MatterPackagesComponent } from './matter-packages/matter-packages.component';
import { WordDocumentsComponent } from './word-documents/word-documents.component';

//test edit in closer web
@Component({
	selector: 'app-documents-v2',
	templateUrl: './documents-v2.component.html',
	imports: [
		CommonModule,
		PageComponent,
		ContentHeaderComponent,
		ButtonComponent,
		TabsComponent,
		TabComponent,
		MatterPackagesComponent,
		ColSpanDirective,
		WordDocumentsComponent,
		TestHookDirective,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentsV2Component {
	testHooks = TestHooks;

	constructor(
		private drawerService: DrawerService,
		private route: ActivatedRoute,
		private analytics: AnalyticsService,
	) {}

	openDocumentsDrawer(): void {
		const currentTab = this.route.snapshot.queryParams['tab'] || 'packages';
		if (currentTab === 'packages') {
			this.analytics.logEvent(AnalyticsEvent.MATTER_PACKAGE_CLICK_ADD);
		}

		if (currentTab === 'my-documents') {
			this.analytics.logEvent(AnalyticsEvent.MATTER_DOCUMENTS_CLICK_ADD);
		}

		this.drawerService.openDrawer(CreateDocPackageDrawerComponent, {
			title: 'Add Documents',
		});
	}
}
